import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ChangelogService, LastChangeProperties } from '../../services/changelog/changelog.service';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss'],
})
export class ChangelogComponent implements OnInit {
  // Variabili per la gestione della CheckBox "Non visualizzare più".
  checked: boolean = false; // contiene il valore del checkBox.
  disabled: boolean; // Serve a disabilitare la modifica della checkBox.
  public accordionFunzionalita: any[] = [];
  public lastVersion: any;
  public history: any[];
  public data: any;
  constructor(private dialogRef: MatDialogRef<ChangelogComponent>, public changelogService: ChangelogService, private configurations: ConfigurationService) {
    // Disabilito la chiusura del popup alla pressione di un tasto del mouse sul backDrop.
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.data = this.changelogService.loadChangeLogs().subscribe((res) => {
      this.data = res;
      if (this.data.length > 1) {
        this.lastVersion = this.data[0];
        this.history = this.data.slice(1);
        this.accordionFunzionalita.push({ id: 1, title: 'Versione ' + this.data[0].version + ' del ' + this.data[0].date });
        this.accordionFunzionalita.push({ id: 2, title: 'Storico versioni' });
      }
      if (this.data.length == 1) {
        this.lastVersion = this.data[0];
        this.accordionFunzionalita.push({ id: 1, title: 'Versione ' + this.data[0].version + ' del ' + this.data[0].date });
      }
    });
  }

  /**
   * Handle event on checkbox
   * @param e event info
   * @param checked the status of the checkbox
   */
  public valueChanged(e) {
    this.configurations.localVersion = Number(`${this.data[0].major}${this.data[0].minor}${this.data[0].patch}`);
    //this.configurations.localVersion = 1290
    this.changelogService.setLastChangelog(LastChangeProperties.changeLogConsulted, this.checked || false, true);
  }

  /**
   * Funzione di decodifica degli stili css utilizzati per la rappresentazione delle modifiche nel changelogs.json.
   * @param changeType Stile della sezione interessata, restituirà l'etichetta da utilizzare per il binding.
   */
  getChangeDescriptionType(changeType: string): string {
    let result: string;

    switch (changeType) {
      case 'added':
        result = 'Novità';
        break;
      case 'fixed':
        result = 'Correzioni';
        break;
      case 'removed':
        result = 'Eliminate';
        break;
      case 'changed':
        result = 'Modificate';
        break;
    }

    return result;
  }
}
